module.exports = __webpack_public_path__ + "static/media/DBMS_logo.8f4018c4.png";